/**
 * @file Button strip of a coach whose last step sends its request: Back, and one forward button reading Finish on the last step.
 * No failure path: the coach owns the request, and `disabledNext` blocks the click.
 */
import * as React from "react";
import Button from '@material-ui/core/Button';

export class ButtonStripForCoach extends React.Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { activeStep, steps, onPageChange, trans, showBackButton, disabledBack, disabledNext } = this.props;
    return (
      <div className="button-container step-footer">
        <div style={{paddingRight: "7px"}}>
        { activeStep !== 0 && showBackButton &&
          <Button
            color="primary"
            variant="outlined"
            onClick={() => onPageChange.apply(this, [activeStep - 1, false])}
            className="back-button"
            disabled={disabledBack}
          >
            {trans("dialog-button/back")}
          </Button>
          }

          <Button
            variant="contained"
            color="primary"
            disabled={disabledNext}
            onClick={() => onPageChange.apply(this, [activeStep + 1, true])}
          >
            {activeStep === steps.length - 1 ? trans("button-finish") : trans("button-next")}
          </Button>
        </div>
      </div>
    );
  }
}
